import { render, staticRenderFns } from "./detailStep.vue?vue&type=template&id=28d014d3&scoped=true"
import script from "./detailStep.vue?vue&type=script&lang=js"
export * from "./detailStep.vue?vue&type=script&lang=js"
import style0 from "./detailStep.vue?vue&type=style&index=0&id=28d014d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d014d3",
  null
  
)

export default component.exports